import { ageFromDob } from "../../../utils/clientAppUtils";
import { useClientAthlete } from "../../../context/ClientAthleteContext";
import s from "../PatientPortal/clientApp.module.css";

export default function ClientChildSwitcher({ compact = false }) {
  const { isParentMode, athletes, activeAthleteId, setActiveAthleteId } =
    useClientAthlete();

  if (!isParentMode || athletes.length <= 1) return null;

  return (
    <div className={compact ? s.childSwitcherCompact : s.childSwitcher}>
      {athletes.map((a) => {
        const age = ageFromDob(a.date_of_birth);
        const active = String(a.id) === String(activeAthleteId);
        return (
          <button
            key={a.id}
            type="button"
            className={active ? s.childSwitcherBtnOn : s.childSwitcherBtn}
            onClick={() => setActiveAthleteId(a.id)}
          >
            <span>{a.full_name}</span>
            {age != null ? <em>{age} лет</em> : null}
          </button>
        );
      })}
    </div>
  );
}
